export const getSplitPath = (
  path: /** a url path beginning with `/` */ string,
): string[] => path.substr(1).split('/');
